module.exports = __webpack_public_path__ + "img/remind.f574fb2b.svg";